module.exports = __webpack_public_path__ + "img/sand-decal-01.a772eafb.png";